export function prettifyEnumLabel(label: string | null | undefined) {
  return label ? label
    .replace(/([A-Z])/g, " $1")
    .toLowerCase()
    .replace(/^ (.)/, (str: string) => str.toUpperCase())
    .trim() : (label ?? "");
}

export function simpleEnumLabel(label: any) {
  return label;
}

export function getEnumValues<T extends {}>(value: T) {
  return Object.keys(value)
    .filter(x => isNaN(Number(x)))
    .map(v => value[v as keyof T]);
}
